import React from 'react';
import '../styles/global.css';  // Import the CSS file

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <h1>Hi, I'm Monica!</h1>
      <p >I'm a Master's student at UC Berkeley studying EECS. I also received my undergraduate degrees from UC Berkeley in Computer Science and Applied Mathematics.</p>

      <p><b>Email:</b> m.tang[at]berkeley[dot]edu</p>
      <h4><a href={require('./resume/Resume_fulltime_MonicaTang.pdf')} target="_blank" rel="noopener noreferrer">Resume</a>&emsp;<a href='https://www.linkedin.com/in/monica-tang-9a6484203/' target="_blank" rel="noopener noreferrer">LinkedIn</a>&emsp;<a href='https://github.com/tangmonica' target="_blank" rel="noopener noreferrer">GitHub</a></h4>
    </div>
  );
};

export default Home;
